import React from "react";
import Message from "./Message";
import "../../assets/styles/messages.css";
import errorImg from "../../assets/images/error-page-top-icon.svg";
import { gtmConstant } from "../../constants/gtmConstant";
import {sendDataLayer} from "../../../src/actions/gtmService";

export default class MessageScreen extends React.Component {
  componentDidMount() {
    if (this.refs.messagescreen) {
      this.refs.messagescreen.scrollIntoView();
      this.refs.messagescreen.focus();
    }
    let { type} = this.props;
    let messageText;
    if (this.props.message) {
       messageText = this.getPlainTextMessage(this.props.message);
    }
    sendDataLayer(gtmConstant.SecretCode.FUNNEL_STEP, {
      process_type: gtmConstant.SecretCode.PROCESS_NAME,
      step_title: gtmConstant.SecretCode.STEP_TITLE.ERROR,
      step_number:0,
      error_type: type === "error" 
      ? `משהו השתבש ${messageText}` 
      : `שים לב ${messageText}`
    });
  }
  getPlainTextMessage(message) {
    if (!message) return "";
    
    if (typeof message === "object" && message.message) {
      return message.message;
    }
    else if (typeof message === "string") {
      return message;
    }
    else if (message.statusDescription) {
      return message.statusDescription;
    }
  
    return "";
  }

  
  render() {
    let { type, text, closeText, okText, onTryAgain, onClose } = this.props;

    closeText = closeText || "יציאה";
    okText = okText || "נסה שנית";

    let getTryAgainButton = () => {
      if (onTryAgain)
        return (
          <button
            type="button"
            className="btn btn-action bg-e color-b f4"
            onClick={onTryAgain}
          >
            {okText}
          </button>
        );
      return null;
    };

    const handleClose = () => {
      sendDataLayer(gtmConstant.SecretCode.FUNNEL_CLICK, {
        process_type: gtmConstant.SecretCode.PROCESS_NAME,
        step_title: gtmConstant.SecretCode.STEP_TITLE.ERROR,
        step_number:0,
        click_text: closeText,
      });
      if (onClose) {
        onClose();
      }
    };

    let getCloseButton = () => {
      if (onClose)
        return (
          <button
            type="button"
            className="btn error bg-c color-a f4"
            ref="messagescreen"
            onClick={handleClose}
          >
            {closeText}
          </button>
        );
      return null;
    };
    let showErrorImg = () => {
      if (this.props.provider === "default") {
        return <img className="cal message-img" src={errorImg} alt="" />;
      } else {
        return (
          <img
            className="message-img"
            src={
              "themes/" +
              window.provider +
              "/images/" +
              (type == "error" ? "stop.svg" : "Heart.svg")
            }
            alt=""
          />
        );
      }
    };

    const getMessageHeader = () => {
      debugger
      return type == "error" ? (
        <div className="note">משהו השתבש</div>
      ) : (
        <div className="note">שים לב</div>
      );
    };

    return (
      <div className="message-screen-wrapper bg-grad">
        <div
          className="message-center"
          role="alertdialog"
          aria-label="שים לב"
          aria-describedby="sr-error-label"
        >
          {showErrorImg()}
          <span id="sr-error-label" className="sr-only">
            this.props.message
          </span>
          <div className="info color-a f4" aria-hidden="true">
            {getMessageHeader()}
            <Message message={this.props.message} />
          </div>
        </div>

        <div>
          <div className="btn-wrapper">{getCloseButton()}</div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/app/MessageScreen.jsx